var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel-body" },
    [
      _c(
        "div",
        {
          staticClass:
            "flex flex-content-center flex-direction-column header-boder mr-b-30 text-plan-normal"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex flex-content-center title text-size-20 font-bold"
            },
            [_vm._v("\n      現在ご利用中のプラン\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex plan-info pd-t-20 pd-b-20  text-center" },
            [
              _c("div", {
                staticClass: "flex flex-content-start flex-basis-25"
              }),
              _vm._v(" "),
              _vm.isBasicPlan
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-content-baseline plan-basic-text font-bold flex-basis-50 margin-auto gap-5"
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "text-size-36 text-plan-basic" },
                        [_vm._v("ベーシック")]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isBasicPlan
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-content-baseline flex-flow-wrap font-bold flex-basis-50 margin-auto"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "plan-premium-text full-width" },
                        [
                          _c("span", { staticClass: "text-size-36" }, [
                            _vm._v("プレミアム")
                          ]),
                          _vm._v(" "),
                          _vm.isPremiumTrial
                            ? _c("span", [_vm._v("(トライアル)")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.planData && _vm.planData.interval === "month"
                            ? _c("span", [_vm._v("（月額払い）")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.planData && _vm.planData.interval === "year"
                            ? _c("span", [_vm._v("（年額払い）")])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _vm.planData &&
                      _vm.planData.currentPeriodStart &&
                      _vm.planData.currentPeriodEnd
                        ? _c("span", { staticClass: "full-width" }, [
                            _vm._v(
                              "期間：" +
                                _vm._s(_vm.planData.currentPeriodStart) +
                                " ～ " +
                                _vm._s(_vm.planData.currentPeriodEnd)
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-flow-column flex-content-start flex-basis-25 text-primary plan-link"
                },
                [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.openConfirmUssageModal()
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "icon-toggle-side-menu fa fa-caret-right"
                      }),
                      _vm._v("ご利用料金の確認")
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.isBasicPlan && !_vm.isPremiumTrial
                    ? _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              _vm.handleChangePlan()
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass:
                              "icon-toggle-side-menu fa fa-caret-right"
                          }),
                          _vm._v("ご利用プラン・お支払い方法の変更")
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isBasicPlan && !_vm.isPremiumTrial
                    ? _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              _vm.openCancelContractModal()
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass:
                              "icon-toggle-side-menu fa fa-caret-right"
                          }),
                          _vm._v("解約する")
                        ]
                      )
                    : _vm._e()
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.isBasicPlan
        ? _c(
            "div",
            {
              staticClass:
                "flex flex-flow-column flex-content-center gap-15 text-plan-normal"
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("p", { staticClass: "text-size-24 font-bold text-center" }, [
                _vm._v(
                  "登録から29日後の解約期限までに解約した場合、料金は一切かかりません。"
                )
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-warning btn-shadow btn-upgrade-plan bd-rds-8 text-size-22 pd-t-20 pd-b-15 pd-r-100 pd-l-100",
                  on: {
                    click: function($event) {
                      _vm.handleUpgradePlan()
                    }
                  }
                },
                [
                  _vm._v("\n      30日間無料で登録する\n      "),
                  _c("i", {
                    staticClass: "fa fa-arrow-circle-right fa-lg",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "text-center" }, [
                _vm._v("無料トライアルは初めて登録する方が対象です")
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isBasicPlan && _vm.isPremiumTrial
        ? _c(
            "div",
            {
              staticClass:
                "flex flex-flow-column flex-content-center gap-15 text-plan-normal"
            },
            [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "trial-premium" }, [
                _c(
                  "div",
                  { staticClass: "flex font-bold gap-5 flex-content-baseline" },
                  [
                    _c("span", { staticClass: "text-size-24" }, [
                      _vm._v("トライアル終了まで 残り")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-size-24",
                        class: {
                          "text-red": _vm.premiumTrialDate <= 7,
                          "text-green": _vm.premiumTrialDate > 7
                        }
                      },
                      [
                        _c("span", { staticClass: "text-size-36" }, [
                          _vm._v(_vm._s(_vm.premiumTrialDate))
                        ]),
                        _vm._v("日\n        ")
                      ]
                    ),
                    _vm._v(" "),
                    _vm.premiumTrialEndDate
                      ? _c("span", { staticClass: "text-size-16" }, [
                          _vm._v(
                            _vm._s(
                              "（" + _vm.premiumTrialEndDate + " 23:59まで）"
                            )
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v("プレミアムの継続は以下よりお申し込みください")
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "text-red", staticStyle: { width: "60%" } },
                  [
                    _vm._v(
                      "\n        トライアルの途中でお申し込みいただいた場合でも、トライアルの残り期間は料金が発生することはありません\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-warning btn-shadow btn-upgrade-plan bd-rds-8 text-size-22 pd-t-20 pd-b-15 pd-r-100 pd-l-100",
                    on: {
                      click: function($event) {
                        _vm.handleUpgradePlan()
                      }
                    }
                  },
                  [
                    _vm._v("\n        プレミアムを継続する\n        "),
                    _c("i", {
                      staticClass: "fa fa-arrow-circle-right fa-lg",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "text-size-16",
                    staticStyle: { width: "70%" }
                  },
                  [
                    _vm._v(
                      "なお、トライアルを終了してベーシックプランとなった場合、STOCKCREW倉庫は自動解約となり、プレミアムプラン向けのサービスのご提供は停止させていただきます。"
                    )
                  ]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        domProps: { innerHTML: _vm._s(_vm.replaceHTMLSellerInfo(_vm.planHtml)) }
      }),
      _vm._v(" "),
      _vm.isBasicPlan
        ? _c(
            "div",
            {
              staticClass:
                "flex flex-flow-column flex-content-center gap-15 text-plan-normal"
            },
            [
              _vm._m(3),
              _vm._v(" "),
              _c("p", { staticClass: "text-size-24 font-bold " }, [
                _vm._v(
                  "登録から29日後の解約期限までに解約した場合、料金は一切かかりません。"
                )
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-warning btn-shadow btn-upgrade-plan bd-rds-8 text-size-22 pd-t-20 pd-b-15 pd-r-100 pd-l-100",
                  on: {
                    click: function($event) {
                      _vm.handleUpgradePlan()
                    }
                  }
                },
                [
                  _vm._v("\n      30日間無料で登録する\n      "),
                  _c("i", {
                    staticClass: "fa fa-arrow-circle-right fa-lg",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("p", [_vm._v("無料トライアルは初めて登録する方が対象です")])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowConfirmUssageModal
        ? _c("confirm-usage-charge", {
            on: { close: _vm.closeConfirmUssageModal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowCancelContractModal
        ? _c("cancel-contract-modal", {
            on: {
              confirm: _vm.handleCancelContractModal,
              close: _vm.closeCancelContractModal
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowNotiCancelContractCompletedModal
        ? _c("noti-cancel-contract-completed-modal", {
            attrs: { message: "プレミアムを解約しました。" },
            on: { close: _vm.closeNotiCancelContractCompletedModal }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex flex-flow-column gap-10 font-bold" },
      [
        _c("div", { staticClass: "flex flex-content-baseline gap-10" }, [
          _c(
            "div",
            {
              staticClass: "plan-premium-text flex flex-content-baseline gap-5"
            },
            [
              _c("span", { staticClass: "text-size-40" }, [
                _vm._v("プレミアム")
              ])
            ]
          ),
          _vm._v("\n        月額 "),
          _c("span", { staticClass: "text-size-40" }, [_vm._v("9,800")]),
          _vm._v(" 円\n        "),
          _c("span", { staticClass: "label-normal" }, [
            _vm._v("(税込 10,780 円)")
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex flex-content-baseline text-size-16 text-center gap-5"
          },
          [
            _c("i", {
              staticClass: "fa fa-hand-pointer-o fa-lg fa-custom",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v("\n        年額払いの場合は\n        "),
            _c("span", { staticClass: "text-size-28" }, [_vm._v("98,000")]),
            _vm._v(" 円\n        "),
            _c("span", { staticClass: "text-size-14 label-normal" }, [
              _vm._v(" (税込 107,800 円)")
            ])
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-size-45 font-bold mr-t-20" }, [
      _vm._v("\n      初回登録なら"),
      _c("span", { staticClass: "text-dark-red" }, [_vm._v("30日間無料")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex flex-flow-column gap-10 font-bold" },
      [
        _c("div", { staticClass: "flex flex-content-baseline gap-10" }, [
          _c(
            "div",
            {
              staticClass: "plan-premium-text flex flex-content-baseline gap-5"
            },
            [
              _c("span", { staticClass: "text-size-40" }, [
                _vm._v("プレミアム")
              ])
            ]
          ),
          _vm._v("\n        月額 "),
          _c("span", { staticClass: "text-size-40" }, [_vm._v("9,800")]),
          _vm._v(" 円\n        "),
          _c("span", { staticClass: "label-normal" }, [
            _vm._v("(税込 10,780 円)")
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex flex-content-baseline text-size-16 text-center gap-5"
          },
          [
            _c("i", {
              staticClass: "fa fa-hand-pointer-o fa-lg fa-custom",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v("\n        年額払いの場合は\n        "),
            _c("span", { staticClass: "text-size-28" }, [_vm._v("98,000")]),
            _vm._v(" 円\n        "),
            _c("span", { staticClass: "text-size-14 label-normal" }, [
              _vm._v(" (税込 107,800 円)")
            ])
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-size-45 font-bold " }, [
      _vm._v("\n      初回登録なら"),
      _c("span", { staticClass: "text-dark-red" }, [_vm._v("30日間無料")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-99ab66d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99ab66d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/setting/PlanInfo.vue
// module id = null
// module chunks = 